import useCookies from '@/hooks/useCookies';
import { http } from '@/utils/http';
import { getOcelotConfig } from 'lib/configs/ocelot';
import { useEffect } from 'react';

export const useUserMigration = () => {
  const [{ login_token }] = useCookies('login_token');

  useEffect(() => {
    const loginV1Enabled = getOcelotConfig('features.login.v1.enabled');

    if (loginV1Enabled && login_token) {
      http.post('/api/user/migration');
    }
  }, [login_token]);
};
